import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Stack, useTheme, useMediaQuery } from "@mui/material";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import { useAuth } from "../../../context/AuthContext";
import { useSystems } from "../../../context/SystemContext";
import ProPlanModal from "../../components/pro/ProPlanModal";
import { useNavigate } from "react-router-dom";

const BannerPrincipal = () => {
  const { user } = useAuth();
  const { activeProfile } = useSystems();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [isProModalOpen, setIsProModalOpen] = useState(false);
  const [trialVencido, setTrialVencido] = useState(false);

  const currentUserId = user?.id || user?.user_id || 1500;

  const esEmpresa = Number(user?.id_tipo) === 2;

  const verificarProActivo = () => {
    try {
      const raw = localStorage.getItem("hitpoly_trial");
      if (raw) {
        const t = JSON.parse(raw);
        if (t && t.fin && new Date(t.fin).getTime() > Date.now()) {
          return true;
        }
      }
    } catch (e) {}
    return false;
  };
  const proActivo = verificarProActivo();

  useEffect(() => {
    const uid = user?.user_id || user?.id || 1500;
    if (!uid || uid === 1500) {
      try {
        const raw = localStorage.getItem("hitpoly_trial");
        if (raw) {
          const t = JSON.parse(raw);
          setTrialVencido(!(t && t.fin && new Date(t.fin).getTime() > Date.now()));
        } else {
          setTrialVencido(false);
        }
      } catch (e) {
        setTrialVencido(false);
      }
      return;
    }
    fetch("https://apiweb.hitpoly.com/ajax/trialsController.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ accion: "estado", usuario_id: uid }),
    })
      .then((r) => r.json())
      .then((d) => {
        console.log("[BannerPrincipal] Respuesta API:", d);
        const rawLocal = localStorage.getItem("hitpoly_trial");
        console.log("[BannerPrincipal] localStorage hitpoly_trial:", rawLocal);
        const finFuture = (d && d.fin && new Date(d.fin).getTime() > Date.now());
        const activoReal = (d && d.status === "success" && (d.activo || finFuture));
        if (activoReal) {
          console.log("[BannerPrincipal] Pro ACTIVO (API).");
          setTrialVencido(false);
        } else if (d && d.status === "success" && !d.activo) {
          console.log("[BannerPrincipal] Pro INACTIVO (API).");
          try {
            if (rawLocal) {
              const t = JSON.parse(rawLocal);
              if (t && t.fin && new Date(t.fin).getTime() <= Date.now()) {
                console.log("[BannerPrincipal] Prueba vencida en localStorage.");
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(true);
              } else {
                console.log("[BannerPrincipal] No hay prueba vencida (nunca tuvo o limpia).");
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(false);
              }
            } else {
              console.log("[BannerPrincipal] No hay localStorage pero API tiene fin.");
              setTrialVencido(!!(d && d.fin));
            }
          } catch (e) {
            console.log("[BannerPrincipal] Error evaluando localStorage:", e);
            localStorage.removeItem("hitpoly_trial");
            setTrialVencido(false);
          }
        } else {
          console.log("[BannerPrincipal] API no devolvió success. Datos:", d);
          try {
            if (rawLocal) {
              const t = JSON.parse(rawLocal);
              if (t && t.fin && new Date(t.fin).getTime() <= Date.now()) {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(true);
              } else {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(false);
              }
            } else {
              setTrialVencido(false);
            }
          } catch (e) {
            setTrialVencido(false);
          }
        }
      })
      .catch((err) => {
        console.log("[BannerPrincipal] Error en fetch de Pro:", err);
        try {
          const raw = localStorage.getItem("hitpoly_trial");
          if (raw) {
            const t = JSON.parse(raw);
            if (t && t.fin && new Date(t.fin).getTime() > Date.now()) {
              setTrialVencido(false); // Si está activa pero falló API, confiar en local
            } else {
              localStorage.removeItem("hitpoly_trial");
              setTrialVencido(!!raw);
            }
          } else {
            setTrialVencido(false);
          }
        } catch (e) {
          setTrialVencido(false);
        }
      });
  }, [user]);

  let btnPrincipal = esEmpresa ? "Mi Empresa" : "Mi Perfil";
  let iconoPrincipal = esEmpresa ? <BusinessCenterIcon /> : <PersonIcon />;
  let linkPrincipal = "/perfil-de-usuario";

  if (activeProfile && activeProfile.type) {
    if (activeProfile.type === 'professional') {
      btnPrincipal = "Mi Perfil Profesional";
      iconoPrincipal = <PersonIcon />;
      linkPrincipal = `/systems/bolsa/perfil-profesional/${activeProfile.id}?userId=${currentUserId}`;
    } else if (activeProfile.type === 'enterprise') {
      btnPrincipal = "Mi Empresa";
      iconoPrincipal = <BusinessCenterIcon />;
      linkPrincipal = `/systems/bolsa/empresa/${activeProfile.id}?userId=${currentUserId}`;
    } else if (activeProfile.type === 'main') {
      btnPrincipal = "Mi Perfil";
      iconoPrincipal = <PersonIcon />;
      linkPrincipal = "/perfil-de-usuario?tab=Publicaciones";
    } else {
      // master o cualquier otro tipo seleccionado
      btnPrincipal = "Mi Perfil";
      iconoPrincipal = <PersonIcon />;
      linkPrincipal = `/perfil-de-usuario?tab=Publicaciones`;
    }
  }

  const contenido = {
    titulo: "Crea y rentabiliza cualquier negocio en internet o ayuda a que esto suceda.",
    subtitulo: "Impulsa tu crecimiento mediante relaciones sólidas de nivel internacional. Estamos creando juntos el sistema de capitalización digital más grande del mundo.",
    btnPrincipal,
    iconoPrincipal,
    linkPrincipal
  };

  return (
    <>
      <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: 180,
        borderRadius: 4,
        background: `linear-gradient(135deg, #8A6CFF 0%, #6C4DE2 35%, #5A3CEB 60%, #3B207F 100%)`,
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: isMobile ? 3 : 5,
        textAlign: "center",
        mb: { xs: 10, md: 6 }, // Aumentado el margen inferior para que el Stack no choque con lo de abajo
        boxShadow: `0 15px 35px rgba(45, 22, 56, 0.35), inset 0 0 25px rgba(255, 255, 255, 0.20)`,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 4 }}>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          component="h1"
          sx={{
            fontWeight: 800,
            textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            maxWidth: { xs: "100%", md: "700px" }, // Limitamos el ancho en PC
            mx: "auto" // Lo centramos
          }}
        >
          {contenido.titulo}
        </Typography>

        <Box sx={{ mt: 1.5, maxWidth: "650px" }}>
          <Typography
            variant="body1"
            sx={{ fontSize: isMobile ? "0.95rem" : "1.15rem", opacity: 0.9, fontWeight: 400 }}
          >
            {contenido.subtitulo}
          </Typography>
        </Box>
      </Box>

      {/* --- CONTENEDOR DE BOTONES CORREGIDO --- */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          position: "absolute",
          bottom: -30,
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "#FFFFFF",
          borderRadius: 10, // Más redondeado para un look premium
          boxShadow: "0 15px 40px rgba(0, 0, 0, 0.15)",

          /* Ajustes de ancho dinámico */
          width: "fit-content", // El padre se ajusta al contenido
          px: { xs: 2, md: 3 },  // Padding a los lados (ajustable)
          py: 1.5,               // Padding arriba y abajo

          zIndex: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          whiteSpace: "nowrap"
        }}
      >
        <Button
          variant="contained"
          startIcon={contenido.iconoPrincipal}
          onClick={() => {
            if ((contenido.btnPrincipal === "Mi Perfil Profesional" || contenido.btnPrincipal === "Mi Empresa") && !proActivo) {
              setIsProModalOpen(true);
              return;
            }
            if (contenido.linkPrincipal && proActivo) {
              navigate(contenido.linkPrincipal);
            } else if (contenido.linkPrincipal) {
              navigate(contenido.linkPrincipal);
            }
          }}
          sx={{
            backgroundColor: "#6C4DE2",
            "&:hover": { backgroundColor: "#3B207F" },
            borderRadius: 8,
            fontWeight: 700,
            textTransform: "none",
            px: 3,
            fontSize: isMobile ? "0.85rem" : "1rem",
          }}
        >
          {contenido.btnPrincipal}
        </Button>

        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => {
            if (!proActivo) {
              setIsProModalOpen(true);
              return;
            }
            navigate("/systems/proyectos?reset=true");
          }}
          sx={{
            borderColor: "#E0E0E0",
            color: "#444",
            "&:hover": {
              borderColor: "#6C4DE2",
              backgroundColor: "rgba(108, 77, 226, 0.05)",
            },
            borderRadius: 8,
            fontWeight: 700,
            textTransform: "none",
            px: 3,
            fontSize: isMobile ? "0.85rem" : "1rem",
          }}
        >
          Proyectos
        </Button>
      </Stack>
    </Box>

    <ProPlanModal vencido={trialVencido}
      open={isProModalOpen}
      onClose={() => setIsProModalOpen(false)}
      herramienta="Perfil Profesional / Empresa"
    />
    </>
  );
};

export default BannerPrincipal;
